


















































import { Component, Vue } from 'vue-property-decorator'
import { BaseStore, LettersType } from '@/store/modules/Base'
import { sendUrl } from '@/api/login'
// import MD5 from 'md5.js'

@Component({
  name: 'Sidebar'
})
export default class Sidebar extends Vue {
  show = true

  get letters (): LettersType {
    return BaseStore.letters
  }

  // 点击返回顶部
  clickUp ():void {
    this.goScrollTop(0, 200)
  }

  // 返回旧版
  goOldVersion ():void {
    const loading = this.$loading({
      lock: true,
      text: '跳转中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    sendUrl()
      .then(res => {
        loading.close()
        if (res.success) {
          const { uuId, webSite } = res.data

          // this.$md5() 和 this.$secretKey()  在全局 plugins 中
          const sign = new this.$md5().update(uuId + this.$secretKey()).digest('hex')
          // window.open(`${webSite}/cm/gtpw_set.jsp?uuId=${uuId}&sign=${sign}&pathCode=0`)
          window.location.href = `${webSite}/cm/gtpw_set.jsp?uuId=${uuId}&sign=${sign}&pathCode=0`
        }
      }).catch(() => {
        // openWind.close()
        loading.close()
      })
  }

  // 操作动画
  goScrollTop (number = 0, time?: number): number | undefined {
    if (!time) {
      document.body.scrollTop = document.documentElement.scrollTop = number
      return number
    }
    const spacingTime = 20 // 设置循环的间隔时间  值越小消耗性能越高
    let spacingInex = time / spacingTime // 计算循环的次数
    let nowTop = document.body.scrollTop + document.documentElement.scrollTop // 获取当前滚动条位置
    const everTop = (number - nowTop) / spacingInex // 计算每次滑动的距离
    const scrollTimer = setInterval(() => {
      if (spacingInex > 0) {
        spacingInex--
        this.goScrollTop(nowTop += everTop)
      } else {
        clearInterval(scrollTimer) // 清除计时器
      }
    }, spacingTime)
  }

  mounted () {
    window.addEventListener('scroll', () => {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop < 100) {
        this.show = false
      } else {
        this.show = true
      }
    })
  }
}
